import { type ReactNode } from 'react'

interface TabBarProps {
  tabs: string[]
  active: string
  onChange: (tab: string) => void
  rightSlot?: ReactNode
}

export function TabBar({ tabs, active, onChange, rightSlot }: TabBarProps) {
  return (
    <div
      className="bg-background-main flex items-center border-l-0.5 border-r-0.5 border-b-0.5 border-border-main"
      style={{
        height: 54,
        padding: '0 20px',
        justifyContent: rightSlot ? 'space-between' : 'flex-start',
      }}
    >
      <div className="flex items-center" style={{ gap: 18 }}>
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => onChange(tab)}
            className={`font-jakarta whitespace-nowrap transition-colors ${
              active === tab ? 'text-white' : 'text-text-support hover:text-white'
            }`}
            style={{
              fontSize: 14,
              background: 'none',
              border: 'none',
              borderBottom: active === tab ? '2px solid #FFFFFF' : '2px solid transparent',
              padding: '16px 0',
              cursor: 'pointer',
            }}
          >
            {tab}
          </button>
        ))}
      </div>

      {rightSlot && (
        <div>{rightSlot}</div>
      )}
    </div>
  )
}
